import React from "react";
import { Box } from "@mui/material";

const formatDateHeader = (date) => {
  const d = new Date(date);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  if (isSameDay(d, today)) return "Today";
  if (isSameDay(d, yesterday)) return "Yesterday";

  return d.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const DateDivider = ({ date }) => (
  <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
    <Box
      sx={{
        px: 2,
        py: 0.5,
        borderRadius: 20,
        bgcolor: "#e0e0e0",
        fontSize: 12,
        color: "#555",
        zIndex: 1,
      }}
    >
      {formatDateHeader(date)}
    </Box>
  </Box>
);

export default DateDivider;
